import React from 'react';
import { IIconProps } from '../interfaces';

const EditIcon = (props: IIconProps) => {

    return (
        <svg
            width={ props.width }
            height={ props.width }
            className={ props.classes }
            viewBox="796 796 200 200"
            xmlns="http://www.w3.org/2000/svg">
            <path fill={ props.color } xmlns="http://www.w3.org/2000/svg" d="M989.732,874.138c-3.462,0-6.268,2.806-6.268,6.268v91.41c0,6.423-5.227,11.648-11.648,11.648H820.184   c-6.423,0-11.648-5.226-11.648-11.648v-151.63c0-6.423,5.226-11.648,11.648-11.648h95.599c3.462,0,6.268-2.806,6.268-6.268   c0-3.461-2.806-6.268-6.268-6.268h-95.599c-13.335,0-24.184,10.849-24.184,24.184v151.63c0,13.335,10.849,24.184,24.184,24.184   h151.632c13.334,0,24.184-10.849,24.184-24.184v-91.41C996,876.944,993.193,874.138,989.732,874.138z"/>
            <path fill={ props.color } xmlns="http://www.w3.org/2000/svg" d="M829.716,963.686h49.934l107.182-107.182c9.43-9.43,9.43-24.772,0-34.203l-15.731-15.732   c-4.567-4.567-10.641-7.083-17.101-7.083c-6.461,0-12.533,2.516-17.102,7.083l-107.182,107.18V963.686z M874.654,950.955   l-32.208-32.207l78.466-78.465l32.207,32.207L874.654,950.955z M945.762,815.434c2.201-2.2,5.127-3.412,8.238-3.412   s6.037,1.211,8.237,3.412l15.73,15.731c4.544,4.542,4.544,11.933,0.001,16.475l-12.924,12.924c-1.69,1.691-4.433,1.691-6.125,0   l-26.081-26.082c-1.691-1.691-1.691-4.434,0-6.125L945.762,815.434z"/>
            <title>{ props.title }</title>

        </svg>)
};

export default EditIcon;
